import type { I_it4CreateContract_Return } from "@/hooks/requests/it4CreateContract/it4CreateContract.types";

import { BugTrackerSection, useBugTracker } from "@/helpers/bugTracker";
import it4CreateContract from "@/hooks/requests/it4CreateContract/it4CreateContract";
import it4SetDeviceStatus from "@/hooks/requests/it4SetDeviceStatus/it4SetDeviceStatus";

export interface CreateContractPayload {
    token: string;
    deviceId: string;
    lang: string;
    firstName: string;
    lastName: string;
    middleName: string;
    mobile: string;
    email: string;
    doc: string;
    docNum: string;
    docPostCode: string;
    docCityName: string;
    docStreet: string;
    docHouseNum: string;
    docIssueDate?: string;
    docExpirationDate?: string;
    docApartmentNum?: string;
    b2bInternationalName?: string;
    b2bVatNumber?: string;
    b2bRegon?: string;
    b2bNRN?: string;
    sign?: boolean;
    hold?: boolean;
}
interface SetDeviceStatusPayload {
    token: string;
    deviceId: string;
    status: "ORDER_CREATED" | "ONLINE_CONTRACT_GENERATED" | "ONLINE_CONTRACT_SIGNED";
}

export async function createContract(
    payload: CreateContractPayload,
): Promise<I_it4CreateContract_Return["data"] | null> {
    try {
        const ContractData = await it4CreateContract(payload);

        useBugTracker("createContract - it4CreateContract (response)", BugTrackerSection.INFO, {
            response: ContractData,
        });

        return ContractData;
    } catch (e) {
        useBugTracker("createContract - it4CreateContract", BugTrackerSection.ERROR, {
            exception: e.message,
            request: payload,
        });

        return null;
    }
}

export async function setDeviceStatus(payload: SetDeviceStatusPayload): Promise<void> {
    try {
        await it4SetDeviceStatus(payload);
    } catch (e) {
        useBugTracker("setDeviceStatus - it4SetDeviceStatus", BugTrackerSection.ERROR, {
            exception: e.message,
            request: payload,
        });
    }
}
